import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import styled from '@emotion/styled';

const HighlightedText = styled(Typography)`
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const RegularText = styled(Typography)`
  font-size: 1rem;
  text-align: center;
`;

const CardWrapper = styled(Card)`
  margin: auto;
  max-width: 600px;
  padding: ${({ theme }) => theme.spacing(2)};
`;

const PageInfo = () => {
  return (
    <CardWrapper>
      <CardContent>
        <HighlightedText variant="h5">
          Encuentra tu aula al instante utilizando el buscador de ClassfiWeb 😊🔍
        </HighlightedText>
        <RegularText variant="body1">
          Nuestro buscador copia automáticamente todas las clases de la HOJA DE DISTRIBUCION DE AULAS al ingresar a la página o al presionar el botón verde de actualización.
        </RegularText>
      </CardContent>
    </CardWrapper>
  );
};

export default PageInfo;
